module.exports = __webpack_public_path__ + "img/CA_new_logo_150x_2x-removebg.43a8d61c.png";